import React from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import { withTheme } from 'react-jss'

import Button from 'components/button'

import styles from 'components/form/form-style'

const FormButtons = ({ theme, cancel, back, isDisabled, submit, loading, t , children}) => {
  const classes = styles(theme)

  return (
    <div className={classes.buttonsBlock}>
      {cancel &&
        <Button classType="cancel" to={cancel}>{t('form.cancel')}</Button>
      }
      {back &&
        <Button classType="cancel" onClick={back}>{t('form.back')}</Button>
      }
      {submit &&
        <Button type="submit" disabled={isDisabled}>
        {loading ? <span className={classNames(classes.loader, 'fal', 'fa-spinner', 'fa-spin')} />
            : (typeof submit === 'string' ? submit : t('form.validate'))
          }
        </Button>
      }
      {children}
    </div>
  )
}

FormButtons.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object.isRequired,
  cancel: PropTypes.string,
  back: PropTypes.func,
  submit: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  isDisabled: PropTypes.bool,
  loading: PropTypes.bool
}

FormButtons.defaultProps = {
  isDisabled: false,
  loading: false
}

export default compose(
  withTranslation(),
  withTheme
)(FormButtons)
